exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntable[data-v-3a51fcd4] {\n  table-layout: fixed;\n}\ntd[data-v-3a51fcd4] {\n    white-space: normal;\n    word-wrap: break-word;\n}\n.modal-dialog[data-v-3a51fcd4] {\n    min-width: 900px;\n}\n.font-bold[data-v-3a51fcd4] {\n    font-weight: bold;\n}\n.font-center[data-v-3a51fcd4] {\n    text-align: center;\n}\n.font-dezoito[data-v-3a51fcd4] {\n    font-size: 18px;\n}\n.color-white[data-v-3a51fcd4] {\n    background-color: #fff;\n}\n\n", ""]);

// exports
